module.exports = __webpack_public_path__ + "static/GT-Haptik-Regular-319b0775027641a50488c288adf3e2da.woff2";